import * as React from "react"
import { Grid, Skeleton, Typography } from "@mui/material"
import { formatDate, FORMAT_DATE_BACK, getPreviousDate } from "@ui-seeker/utils"

import { KpiTable } from "@components"
import { DATE_PERIODS, GROUPED_BY } from "@constants"
import { commonFiltersValue, country, isLoadingCommonFilters, retailer } from "@signals"
import ShareOfSearchKpiTabs from "./Tabs"
import { useShareOfSearchKpiFilters } from "../@hooks"
import {
	shareOfSearchKpiDetailsFilters, shareOfSearchKpiEndDate, shareOfSearchKpiEvolutionFilters, shareOfSearchKpiEvolutionKeywordsOptions, shareOfSearchKpiEvolutionCurrentPeriod
} from "../@signals"


export default function ShareOfSearchKpiTable() {
	const { data, aggregation, keywords, keywordType, handleTabChange } = useShareOfSearchKpiFilters()
    const newFilters = commonFiltersValue.peek()

	if (isLoadingCommonFilters.value)
		return <Skeleton variant="rectangular" height={500} />

	if (aggregation.length === 0)
		return <></>

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<ShareOfSearchKpiTabs
				value={keywordType}
				onChange={handleTabChange}
			/>
		</Grid>

		<Grid item xs={12}>
			{ !data.length && <Typography sx={{ mt: 3, textAlign: 'center'}}>There is no data available for the selected keyword as it is not associated with any brands</Typography>}
			{!!data.length && <KpiTable
				data={data}
				aggregations={aggregation}
				showOverallStyles
				kpis={keywords.map(keyword => ({
					name: keyword,
					label: keyword,
					links: [{
						icon: 'radar',
						label: 'Split by keyword',
						onClick: (dataRow, aggregations) => {
							const isAll = dataRow?.country === 'All' || dataRow?.retailer === 'All'
							shareOfSearchKpiDetailsFilters.value = {
								[keywordType]: keyword === 'Overall Score' ? [] : [dataRow[`${keyword}ID`]],
								...aggregations.includes(GROUPED_BY.COUNTRY) && { country: isAll ? country.value : [dataRow.country] },
								...aggregations.includes(GROUPED_BY.RETAILER) && { retailer: isAll ? retailer.value : [dataRow.siteID] },
								...aggregations.includes(GROUPED_BY.BRAND) && { brand: [dataRow.brandID] }
							}
						}
					}, {
						icon: 'chart-line',
						label: 'Show KPI Evolution',
						onClick: (dataRow, aggregations) => {
                            shareOfSearchKpiEndDate.value = newFilters.endDate
                            let startDate = formatDate(getPreviousDate({days: 6}, shareOfSearchKpiEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

                            shareOfSearchKpiEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

							shareOfSearchKpiEvolutionKeywordsOptions.value = {}
							shareOfSearchKpiEvolutionFilters.value = {
								keywordType: keywordType,
								[keywordType]: [dataRow[`${keyword}ID`]],
								startDate: startDate,
								endDate: shareOfSearchKpiEndDate.value,
								...aggregations.includes(GROUPED_BY.COUNTRY) && { country: [dataRow.country] },
								...aggregations.includes(GROUPED_BY.RETAILER) && { retailer: [dataRow.siteID] },
								...aggregations.includes(GROUPED_BY.BRAND) && { brand: [dataRow.brandID] }
							}
						}
					}]
				}))}
			/>}
		</Grid>
	</Grid>
}